import { getQueryParamsFromString } from '__utils/common-utils';

const USER_LOGIN_COOKIE = process.env.REACT_APP_USER_LOGIN_COOKIE_NAME;
const USER_CART_COOKIE = process.env.REACT_APP_CART_COOKIE_NAME;
const COOKIE_URL: string = process.env.REACT_APP_COOKIE_URL || window.location.hostname;
// const CART_COOKIE = process.env.REACT_APP_CART_COOKIE_NAME;
const AGENT_CODE_COOKIE = 'agentCode';
const RANDOM_COOKIE = 'cookieId';
const SERVICE_TEMPLATE__URL = process.env.REACT_APP_MINTPRO_URL;

export const read_cookie = (name: string) => {
	let result = document.cookie.match(new RegExp(name + "=([^;]+)"));
	if (result)
	{
		return decodeURIComponent(result[ 1 ])
	}
	return null;
};

export const set_cookie = (name: any, value: string, isDomainLess?: boolean) => {
	
	if(isDomainLess){
		document.cookie = name + "=" + (encodeURIComponent(value) || "") + ';path=/;';
	}else{
		document.cookie = name + "=" + (encodeURIComponent(value) || "") + `;domain=${COOKIE_URL};path=/;`;
	}
};
const set_login_cookie = (name: any, value: string) => {
	document.cookie = name + "=" + (encodeURIComponent(value) || "") + ';path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
};

export const delete_cookie = (name: string, isDomainLess?: boolean) => {
	if(isDomainLess){
		document.cookie = name +'=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}else{
		document.cookie = name + "=" + `; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
	}
};
export const delete_cookie_by_domain = (name: string) => {
	document.cookie = name + "=" + `; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.${COOKIE_URL}`
};

export const getRandomCookie = () => {
	return read_cookie(RANDOM_COOKIE);
}
export const clearListCookies = () => {
	var cookies = document.cookie.split(";");
	for (var i = 0; i < cookies?.length; i++)
	{
		var spcook = cookies[ i ].split("=");
		delete_cookie(spcook[ 0 ]);
	}
};
export const setRandomCookie = () => {
	const value = "c" + Math.random().toString(36).substring(7);
	sessionStorage.setItem("cookieId",value);
	set_cookie("cookieId", value, true)
}

export const getAgentCode = () => {
	let agentCodeSession = sessionStorage.getItem("agentCodeCookie");
    const { agentCode } = getQueryParamsFromString(window.location.search);
    if(agentCodeSession){
        return agentCodeSession;
    }
    return read_cookie(AGENT_CODE_COOKIE) || agentCode;
}

export const setAgentCode = (value: string) => {
	set_cookie(AGENT_CODE_COOKIE, value, true);
	sessionStorage.setItem("agentCodeCookie",value); 
}

export const getUserDetails = () => {
	
	let userInfoSession = sessionStorage.getItem("userInfo");
	if(userInfoSession){
		let userInfoSessionJson= JSON.parse(userInfoSession);
		return userInfoSessionJson?.user;
	}
	if (USER_LOGIN_COOKIE)
	{
		let userInfo: any = read_cookie(USER_LOGIN_COOKIE);
		if (userInfo)
		{
			let userInfoJson = JSON.parse(userInfo);
			return userInfoJson?.user
		}
		
	}
	return null;
}
export const getOrgCartInfo = () => {
	
	if (USER_CART_COOKIE)
	{
		let orgCartInfoSession = sessionStorage.getItem(USER_CART_COOKIE);
		if(orgCartInfoSession){
			let orgCartInfoSessionJson= JSON.parse(orgCartInfoSession);
			return orgCartInfoSessionJson;
		}
		let orgCartInfo: any = read_cookie(USER_CART_COOKIE);
		if (orgCartInfo)
		{
			let orgCartInfoJson = JSON.parse(orgCartInfo);
			return orgCartInfoJson
		}
	}
	return null;
}

export const setUserDetails = (userDetails: any) => {
	if (USER_LOGIN_COOKIE) {
		set_login_cookie(USER_LOGIN_COOKIE, JSON.stringify(userDetails));
		sessionStorage.setItem('userInfo',JSON.stringify(userDetails));
	}
}

export const removeUserDetails = () => {
	window.sessionStorage.removeItem('userInfo');
	if (USER_LOGIN_COOKIE) delete_cookie(USER_LOGIN_COOKIE);
}
export const removeCartDetails = () => {
	if (USER_CART_COOKIE) delete_cookie(USER_CART_COOKIE);
	if(sessionStorage.getItem(USER_CART_COOKIE!)) window.sessionStorage.removeItem(USER_CART_COOKIE!);
}

export const getUserToken = () => {
	let userInfoSession = sessionStorage.getItem("userInfo");
	if(userInfoSession){
		let userInfoSessionJson= JSON.parse(userInfoSession);
		return userInfoSessionJson?.token;
	}
	if (USER_LOGIN_COOKIE)
	{
		let userInfo: any = read_cookie(USER_LOGIN_COOKIE);
		if (userInfo)
		{
			let userInfoJson = JSON.parse(userInfo.split('domain=')[ 0 ]);
			return userInfoJson?.token;
		}
	} else
	{
		return null;
	}
}
export const getMinorToMajorToken = () => {
	if(sessionStorage.getItem('minorToken')) {
		let token = sessionStorage.getItem('minorToken');
		return token;
	} else {
		return null;
	}
}
// registerwithBse

export const setKycInCookie = (data: any) => {
	sessionStorage.setItem('kycDetailsCoookie',JSON.stringify(data));
	set_cookie('kycDetailsCookie', JSON.stringify(data));
}
export const getDataFromKycCookie = () => {
	let kycInfoSession = sessionStorage.getItem('kycDetailsCookie');
	if(kycInfoSession){
		let kycInfoSessionJson= JSON.parse(kycInfoSession);
		return kycInfoSessionJson;
	}
	let kycData: any = read_cookie('kycDetailsCookie');
	if (kycData)
	{
		let kycDataJson = JSON.parse(kycData);
		return kycDataJson
	}

}

export const setOrgCartInfo = (data: any) => {
	var orgCartInfoObject = { cartId: data?.encryptedCartId };
	set_cookie(USER_CART_COOKIE,JSON.stringify(orgCartInfoObject));
	if(USER_CART_COOKIE){
		sessionStorage.setItem(USER_CART_COOKIE,JSON.stringify(orgCartInfoObject));
	}
	
}

export const setOrgCartInfoFromSession = (cartInfo: any) => {
	if(cartInfo){
		set_cookie(USER_CART_COOKIE,cartInfo);
	}	
}

export const setCookieId = (value: any) => {
	if(value){
		set_cookie('cookieId',value,true);
	}	
}

export const delete_cookie_byDomain = (name: string, domainName: string) => {
	document.cookie = name + "=" + `;domain=${domainName}; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export const set_cookie_byDomain = (name: any, value: string, domianName: string) => {
	document.cookie = name + "=" + (encodeURIComponent(value) || "") + `;domain=${domianName};path=/;`;	

};

export const getServiceTmpUrl = () => {
	return SERVICE_TEMPLATE__URL ;
}

export const get_item_from_localStorage = (item: any)=>{
	return window.localStorage.getItem(item);
}
export const set_item_in_localStorage = (item: string,value: string)=>{
	window.localStorage.setItem(item, value);
}